module.exports = __webpack_public_path__ + "4d04c9ae0bc88f32b3c33bf82fe1a45f.png";